/**
 * Theme debug helper.
 *
 * Automatically enqueued when a child theme loads this parent.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const message = 'Theme debug helper loaded.';
	if ( window.cultmetricsDebug && typeof window.cultmetricsDebug.log === 'function' ) {
		window.cultmetricsDebug.log( message );
	} else {
		console.log( message );
	}
} );
